import axios from 'axios';
import { IDatabase } from '../../database';
import { rootGizmoDataV2ToV3 } from '../../gizmos/utils';
import { IRootGizmoData, IUserV2 } from '../../types';

interface IParams {
  rgfid: string;
  fid: string;
  context: {
    apiUrl: string;
    user?: IUserV2;
    database?: IDatabase;
  };
}

/**
 * Get root gizmo data from the server
 *
 * @param {string} rgfid Flowy id of the root gizmo
 * @param {string} fid Flowy id of the root gizmo data
 *
 * @returns {IRootGizmoData[]} array of root gizmo data from the server
 */
function getRootGizmoData({
  rgfid,
  fid,
  context,
}: IParams): Promise<IRootGizmoData[]> {
  return new Promise<IRootGizmoData[]>(async resolve => {
    const { apiUrl, user, database } = context;
    let rootGizmoData: IRootGizmoData[] = [];

    if (user?.credentials) {
      const credentials: any = user.credentials;
      const url = `${apiUrl}/main_api/v1/root_gizmo/data/${rgfid}/d`;
      const rootGizmoDataResponse = await axios.post(
        url,
        {
          fids: [fid],
        },
        {
          headers: {
            ...credentials,
          },
        }
      );

      if (rootGizmoDataResponse.status === 200) {
        const { registers } = rootGizmoDataResponse.data;

        if (registers && Array.isArray(registers) && registers.length > 0) {
          if (database) {
            for (const register of registers) {
              await database.set({
                type: 'filledForms',
                value: register,
                update: true,
              });
            }
          }

          rootGizmoData = rootGizmoData.concat(
            registers.map(r => rootGizmoDataV2ToV3({ data: r }))
          );
        }
      }
    }

    resolve(rootGizmoData);
  });
}

export default getRootGizmoData;
